module.exports = __webpack_public_path__ + "img/video-popup-light.61c54092.png";